import { InjectionToken, Type } from '@angular/core';

export const TRANSLATION_CREATION_DIALOG_COMPONENT = new InjectionToken<Type<any>>(
	'TranslationCreationDialogComponent'
);
